/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ApiResponse } from './ApiResponse';
import type { HeadersMap } from './HeadersMap';
import { PbkHeaders } from './PbkHeaders';

export type ApiV2Paged<T> = {
  meta: ApiResponse<unknown>['meta'];
  data: {
    items: T[];
    pageSize?: number;
    totalSize?: number;
    pageNumber?: number;
    hasNextPage?: boolean;
    hasPreviousPage?: boolean;
  };
};

export type ApiV2Unpaged<T> = {
  meta: ApiResponse<unknown>['meta'];
  data: T;
};

export const isV2Format = (headers: HeadersMap): boolean => {
  return headers[PbkHeaders.PbkFormat] === 'v2';
};

export const isV2Paged = <T>(payload: any): payload is ApiV2Paged<T> => {
  return !!(payload && typeof payload === 'object' && payload.data && typeof payload.data === 'object' && Array.isArray(payload.data.items));
};

export const normalizeV2Paged = <T>(v2: ApiV2Paged<T>, status: number, headers: HeadersMap): ApiResponse<T[]> => {
  const items = v2.data.items;

  const totalCount = v2.data.totalSize ?? items.length;

  const totalPages =
    v2.data.pageSize && v2.data.totalSize !== null && v2.data.totalSize !== undefined ? Math.ceil(v2.data.totalSize / v2.data.pageSize) : 1;

  return {
    meta: v2.meta,
    data: items,
    pageNumber: v2.data.pageNumber,
    hasNextPage: v2.data.hasNextPage,
    hasPreviousPage: v2.data.hasPreviousPage,
    totalCount,
    totalPages,
    status,
    headers,
  };
};

export const normalizeV2Unpaged = <T>(v2: ApiV2Unpaged<T>, status: number, headers: HeadersMap): ApiResponse<T> => {
  return {
    meta: v2.meta,
    data: v2.data,
    status,
    headers,
  };
};

export type ApiV2Response<T> = ApiV2Paged<T> | ApiV2Unpaged<T>;
